import _ from "lodash";
import * as types from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_CONTACT_DETAILS:
      return { ..._.mapKeys(action.payload, "Id") };
    case types.FETCH_CONTACT_DETAIL:
      return { [action.payload.EmployeeId]: action.payload };
    case types.CREATE_CONTACT_DETAIL:
      return { ...state, [action.payload.EmployeeId]: action.payload };
    case types.EDIT_CONTACT_DETAIL:
      return { ...state, [action.payload.EmployeeId]: action.payload };
    case types.DELETE_CONTACT_DETAIL:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
